import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import CustomerService from "../../api/customer";
import {
  setMattressConfiguration,
  setMattressGlobalState,
} from "./mattressConfiguration";

const initialState = {
  customer: {
    id: "",
    address: {
      address1: "",
      address2: "",
      city: "",
      company: "",
      country: "Canada",
      countryCode: "CA",
      firstName: "",
      lastName: "",
      province: "",
      provinceCode: "",
      zip: "",
    },
    firstName: "",
    lastName: "",
    email: "",
    emailError: false,
    emailNotFound: false,
    metafields: {
      edges: [
        {
          node: {
            id: "",
            key: "",
            type: "json",
            value: "",
          },
        },
      ],
    },
    // phone: "1234567890",
  },
  loading: false,
  error: false,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomerData: (state, action) => {
      state.customer = action.payload.customer;
    },

    setCustomerError: state => {
      state.error = true;
    },
    resetCustomerError: state => {
      state.error = false;
    },
    setFirstName: (state, action) => {
      state.customer.firstName = action.payload;
    },
    setEmail: (state, action) => {
      state.customer.email = action.payload;
    },
    setEmailError: (state, action) => {
      state.customer.emailError = action.payload;
    },
    setEmailNotFound: (state, action) => {
      state.customer.emailNotFound = action.payload;
    },
    resetEmailError: state => {
      state.customer.emailError = false;
      state.customer.emailNotFound = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCustomerByEmail.pending, state => {
        state.loading = true;
      })
      .addCase(fetchCustomerByEmail.rejected, state => {
        state.loading = true;
      })
      .addCase(fetchCustomerByEmail.fulfilled, (state, action) => {
        const { data, code, isSuccessful } = action.payload;
        const shopifyCustomerObject = data?.[0]?.node;
        // console.log(
        //   "=>(customer.js:88) shopifyCustomerObject",
        //   shopifyCustomerObject
        // );
        if (code === 404) {
          state.customer.emailNotFound = true;
        } else if (!isSuccessful) {
          state.customer.emailError = true;
        } else {
          state.customer = shopifyCustomerObject;
        }

        return state;
      })
      .addCase(createCustomer.pending, state => {
        state.loading = true;
      })
      .addCase(createCustomer.rejected, state => {
        state.loading = true;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.customer = action.payload?.data?.customer;
        return state;
      })

      .addDefaultCase((state, action) => {
        return state;
      });
  },
});

//THUNKS
export const fetchCustomerByEmail = createAsyncThunk(
  "slices/queryCustomer",
  async ({ email, localStorageConfigExists }, { dispatch }) => {
    resetEmailError();
    const { data, code, isSuccessful } = await CustomerService.queryCustomer({
      email,
    });
    // console.log("=>(customer.js:147) localStorageConfigExists", localStorageConfigExists);
    if (!localStorageConfigExists) {
      // console.log("data", data);
      const mattressConfigurationString =
        data?.[0]?.node?.metafields?.edges?.[0]?.node?.value;

      const mattressConfiguration = JSON.parse(mattressConfigurationString);
      // console.log(
      //   "=>(customer.js:135) mattressConfiguration",
      //   mattressConfiguration
      // );
      if (mattressConfiguration) {
        // console.log("inside mattressConfiguration IF", mattressConfiguration);
        dispatch(setMattressGlobalState(mattressConfiguration));
      }
    }
    return { data, code, isSuccessful };
  }
);

export const createCustomer = createAsyncThunk(
  "slices/createCustomer",
  async customer => {
    resetCustomerError();
    const { data, code, isSuccessful } = await CustomerService.createCustomer(
      customer
    );
    return { data, code, isSuccessful };
  }
);

export const {
  setCustomerData,
  resetCustomerError,
  setCustomerError,
  setFirstName,
  setEmail,
  setEmailError,
  resetEmailError,
  setEmailNotFound,
} = customerSlice.actions;

export default customerSlice.reducer;

export const customerEmailSelector = state => state.customer.customer.email;
export const customerEmailNotFoundSelector = state =>
  state.customer.customer.emailNotFound;
export const customerEmailAddressSelector = state =>
  state.customer.customer.email;
export const shopifyCustomerSelector = state => state.customer.customer;
export const metaFieldIdSelector = state =>
  state.customer.customer.metafields.edges[0]?.node?.id;
